<template>
    <div class="infoCard">
        <div class="title">
            <yellow-mark></yellow-mark>
            <span>基本信息</span>
        </div>
        <div class="info">
            <div class="item">
                <span>机构名称:</span>
                <span>{{ item.orgName }}</span>
            </div>
            <div class="item">
                <span>机构类型:</span>
                <span>{{ item.orgType | transOrgType }}</span>
            </div>
            <div class="item">
                <span>成立时间:</span>
                <span>{{ item.establishTime }}</span>
            </div>
            <div class="item">
                <span>开放状态:</span>
                <span>{{ item.openState }}</span>
            </div>
            <div class="item">
                <span>电话:</span>
                <span>{{ item.phone }}</span>
            </div>
            <div class="item">
                <span>地址:</span>
                <span>{{ item.addr }}</span>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "infoCard",
    props: {
        item: {
            default: () => {
                return {};
            },
            required: true,
            type: Object
        }
    },
    methods: {}
};
</script>

<style lang="scss" scoped>
.infoCard {
    border-bottom: 4px solid #fff8e9;
    .title {
        span {
            margin-left: 13px;
            width: 56px;
            height: 20px;
            opacity: 1;
            font-size: 14px;
            font-family: PingFang SC, PingFang SC-Bold;
            font-weight: 700;
            text-align: left;
            color: #543302;
            line-height: 30px;
        }
    }
    .info {
        margin-left: 20px;
        .item {
            display: flex;
            padding-top: 10px;
            padding-right: 20px;
            span {
                &:nth-child(1) {
                    display: inline-block;
                    width: 80px;
                    opacity: 1;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Bold;
                    font-weight: 700;
                    text-align: left;
                    color: #757a8c;
                    line-height: 28px;
                }
                &:nth-child(2) {
                    width: calc(100vw - 40px - 80px);
                    opacity: 1;
                    font-size: 14px;
                    font-family: PingFang SC, PingFang SC-Bold;
                    font-weight: 700;
                    text-align: left;
                    color: #543302;
                    line-height: 29px;
                }
            }
        }
    }
}
</style>
